import {useGetSolutionDrug} from '@/modules/drug-catalog/solutions/api'
import {useGetActiveSubstanceDrug} from '@/modules/drug-catalog/substances/api'
import {useGetSupportiveMedicationDrug} from '@/modules/drug-catalog/supportive-medications/api'
import {CatalogType} from '@cypro/engine/database/schema'

export function useSelectedDrugItem(type: string, drugCatalogItemId: string | undefined) {
  switch (type) {
    case CatalogType.enum.ACTIVE_SUBSTANCE:
      return useGetActiveSubstanceDrug(drugCatalogItemId)
    case CatalogType.enum.SUPPORTIVE_MEDICATION:
      return useGetSupportiveMedicationDrug(drugCatalogItemId)
    case CatalogType.enum.SOLUTION:
    default:
      return useGetSolutionDrug(drugCatalogItemId)
  }
}
